import { LoadingService } from "./loading-service";

export abstract class InitialLoadAction<T> {
    constructor(
        private name : string,
        private loadingService : LoadingService) {}

    private onStart() {
        this.loadingService.loadInProgress();
    }

    private onStop() {
        this.loadingService.loadEnded();
    }

    abstract onLoad() : Promise<T>;

    load() {
        console.log(`Load for ${this.name} started ...`)
        this.onStart();
        this.onLoad().then(
            () => {
                this.onStop(); 
                console.log(`Load for ${this.name} ended ...`);
            }
        );
    }
}